/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { withoutUndefinedValues } from "@pagopa/ts-commons/lib/types";
import {
  RequestParams,
  TypeofApiCall,
  TypeofApiParams,
  createFetchRequestForApi,
  ReplaceRequestParams
} from "@pagopa/ts-commons/lib/requests";
import { identity } from "fp-ts/lib/function";

import {
  GetAbiListUsingGETT,
  getAbiListUsingGETDefaultDecoder,
  AddWalletsBancomatCardUsingPOSTT,
  addWalletsBancomatCardUsingPOSTDefaultDecoder,
  GetPansUsingGETT,
  getPansUsingGETDefaultDecoder,
  AddWalletsBPayUsingPOSTT,
  addWalletsBPayUsingPOSTDefaultDecoder,
  GetBpayListUsingGETT,
  getBpayListUsingGETDefaultDecoder,
  PayCreditCardVerificationUsingPOSTT,
  payCreditCardVerificationUsingPOSTDefaultDecoder,
  DeletePaymentUsingDELETET,
  deletePaymentUsingDELETEDefaultDecoder,
  CheckPaymentUsingGETT,
  checkPaymentUsingGETDefaultDecoder,
  GetPaymentUsingGETT,
  getPaymentUsingGETDefaultDecoder,
  DeleteBySessionCookieExpiredUsingDELETET,
  deleteBySessionCookieExpiredUsingDELETEDefaultDecoder,
  PaySslUsingPOSTT,
  paySslUsingPOSTDefaultDecoder,
  GetPspListUsingGETT,
  getPspListUsingGETDefaultDecoder,
  GetAllPspsUsingGETT,
  getAllPspsUsingGETDefaultDecoder,
  GetSelectedPspUsingGETT,
  getSelectedPspUsingGETDefaultDecoder,
  GetPspUsingGETT,
  getPspUsingGETDefaultDecoder,
  GetResourcesUsingGETT,
  getResourcesUsingGETDefaultDecoder,
  GetImageWithMediaTypeUsingGETT,
  getImageWithMediaTypeUsingGETDefaultDecoder,
  GetPspLogoUsingGETT,
  getPspLogoUsingGETDefaultDecoder,
  GetServiceLogoUsingGETT,
  getServiceLogoUsingGETDefaultDecoder,
  AddWalletSatispayUsingPOSTT,
  addWalletSatispayUsingPOSTDefaultDecoder,
  GetConsumerUsingGETT,
  getConsumerUsingGETDefaultDecoder,
  GetTransactionsUsingGETT,
  getTransactionsUsingGETDefaultDecoder,
  GetTransactionUsingGETT,
  getTransactionUsingGETDefaultDecoder,
  CheckStatusUsingGETT,
  checkStatusUsingGETDefaultDecoder,
  ResumeUsingPOSTT,
  resumeUsingPOSTDefaultDecoder,
  GetUserUsingGETT,
  getUserUsingGETDefaultDecoder,
  SendOtpUsingPOSTT,
  sendOtpUsingPOSTDefaultDecoder,
  StartSessionUsingGETT,
  startSessionUsingGETDefaultDecoder,
  VerifyOtpUsingPOSTT,
  verifyOtpUsingPOSTDefaultDecoder,
  GetWalletsUsingGETT,
  getWalletsUsingGETDefaultDecoder,
  AddWalletUsingPOSTT,
  addWalletUsingPOSTDefaultDecoder,
  CheckCardBinUsingPOSTT,
  checkCardBinUsingPOSTDefaultDecoder,
  AddWalletCreditCardUsingPOSTT,
  addWalletCreditCardUsingPOSTDefaultDecoder,
  UpdateWalletUsingPUTV2T,
  updateWalletUsingPUTV2DefaultDecoder,
  GetWalletUsingGETT,
  getWalletUsingGETDefaultDecoder,
  DeleteWalletUsingDELETET,
  deleteWalletUsingDELETEDefaultDecoder,
  ConfirmWalletUsingPOSTT,
  confirmWalletUsingPOSTDefaultDecoder,
  FavouriteWalletUsingPOSTT,
  favouriteWalletUsingPOSTDefaultDecoder,
  Pay3dsUsingPOSTT,
  pay3dsUsingPOSTDefaultDecoder,
  GetWalletsV2UsingGETT,
  getWalletsV2UsingGETDefaultDecoder,
  ChangePayOptionT,
  changePayOptionDefaultDecoder,
  DeleteWalletsByServiceUsingDELETET,
  deleteWalletsByServiceUsingDELETEDefaultDecoder,
  GetPspListV2UsingGETT,
  getPspListV2UsingGETDefaultDecoder,
  GetPaypalPspsUsingGETT,
  getPaypalPspsUsingGETDefaultDecoder
} from "./requestTypes";

// This is a placeholder for undefined when dealing with object keys
// Typescript doesn't perform well when narrowing a union type which includes string and undefined
// (example: "foo" | "bar" | undefined)
// We use this as a placeholder for type parameters indicating "no key"
type __UNDEFINED_KEY = "_____";

export type ApiOperation = TypeofApiCall<GetAbiListUsingGETT> &
  TypeofApiCall<AddWalletsBancomatCardUsingPOSTT> &
  TypeofApiCall<GetPansUsingGETT> &
  TypeofApiCall<AddWalletsBPayUsingPOSTT> &
  TypeofApiCall<GetBpayListUsingGETT> &
  TypeofApiCall<PayCreditCardVerificationUsingPOSTT> &
  TypeofApiCall<DeletePaymentUsingDELETET> &
  TypeofApiCall<CheckPaymentUsingGETT> &
  TypeofApiCall<GetPaymentUsingGETT> &
  TypeofApiCall<DeleteBySessionCookieExpiredUsingDELETET> &
  TypeofApiCall<PaySslUsingPOSTT> &
  TypeofApiCall<GetPspListUsingGETT> &
  TypeofApiCall<GetAllPspsUsingGETT> &
  TypeofApiCall<GetSelectedPspUsingGETT> &
  TypeofApiCall<GetPspUsingGETT> &
  TypeofApiCall<GetResourcesUsingGETT> &
  TypeofApiCall<GetImageWithMediaTypeUsingGETT> &
  TypeofApiCall<GetPspLogoUsingGETT> &
  TypeofApiCall<GetServiceLogoUsingGETT> &
  TypeofApiCall<AddWalletSatispayUsingPOSTT> &
  TypeofApiCall<GetConsumerUsingGETT> &
  TypeofApiCall<GetTransactionsUsingGETT> &
  TypeofApiCall<GetTransactionUsingGETT> &
  TypeofApiCall<CheckStatusUsingGETT> &
  TypeofApiCall<ResumeUsingPOSTT> &
  TypeofApiCall<GetUserUsingGETT> &
  TypeofApiCall<SendOtpUsingPOSTT> &
  TypeofApiCall<StartSessionUsingGETT> &
  TypeofApiCall<VerifyOtpUsingPOSTT> &
  TypeofApiCall<GetWalletsUsingGETT> &
  TypeofApiCall<AddWalletUsingPOSTT> &
  TypeofApiCall<CheckCardBinUsingPOSTT> &
  TypeofApiCall<AddWalletCreditCardUsingPOSTT> &
  TypeofApiCall<UpdateWalletUsingPUTV2T> &
  TypeofApiCall<GetWalletUsingGETT> &
  TypeofApiCall<DeleteWalletUsingDELETET> &
  TypeofApiCall<ConfirmWalletUsingPOSTT> &
  TypeofApiCall<FavouriteWalletUsingPOSTT> &
  TypeofApiCall<Pay3dsUsingPOSTT> &
  TypeofApiCall<GetWalletsV2UsingGETT> &
  TypeofApiCall<ChangePayOptionT> &
  TypeofApiCall<DeleteWalletsByServiceUsingDELETET> &
  TypeofApiCall<GetPspListV2UsingGETT> &
  TypeofApiCall<GetPaypalPspsUsingGETT>;

export type ParamKeys = keyof (TypeofApiParams<GetAbiListUsingGETT> &
  TypeofApiParams<AddWalletsBancomatCardUsingPOSTT> &
  TypeofApiParams<GetPansUsingGETT> &
  TypeofApiParams<AddWalletsBPayUsingPOSTT> &
  TypeofApiParams<GetBpayListUsingGETT> &
  TypeofApiParams<PayCreditCardVerificationUsingPOSTT> &
  TypeofApiParams<DeletePaymentUsingDELETET> &
  TypeofApiParams<CheckPaymentUsingGETT> &
  TypeofApiParams<GetPaymentUsingGETT> &
  TypeofApiParams<DeleteBySessionCookieExpiredUsingDELETET> &
  TypeofApiParams<PaySslUsingPOSTT> &
  TypeofApiParams<GetPspListUsingGETT> &
  TypeofApiParams<GetAllPspsUsingGETT> &
  TypeofApiParams<GetSelectedPspUsingGETT> &
  TypeofApiParams<GetPspUsingGETT> &
  TypeofApiParams<GetResourcesUsingGETT> &
  TypeofApiParams<GetImageWithMediaTypeUsingGETT> &
  TypeofApiParams<GetPspLogoUsingGETT> &
  TypeofApiParams<GetServiceLogoUsingGETT> &
  TypeofApiParams<AddWalletSatispayUsingPOSTT> &
  TypeofApiParams<GetConsumerUsingGETT> &
  TypeofApiParams<GetTransactionsUsingGETT> &
  TypeofApiParams<GetTransactionUsingGETT> &
  TypeofApiParams<CheckStatusUsingGETT> &
  TypeofApiParams<ResumeUsingPOSTT> &
  TypeofApiParams<GetUserUsingGETT> &
  TypeofApiParams<SendOtpUsingPOSTT> &
  TypeofApiParams<StartSessionUsingGETT> &
  TypeofApiParams<VerifyOtpUsingPOSTT> &
  TypeofApiParams<GetWalletsUsingGETT> &
  TypeofApiParams<AddWalletUsingPOSTT> &
  TypeofApiParams<CheckCardBinUsingPOSTT> &
  TypeofApiParams<AddWalletCreditCardUsingPOSTT> &
  TypeofApiParams<UpdateWalletUsingPUTV2T> &
  TypeofApiParams<GetWalletUsingGETT> &
  TypeofApiParams<DeleteWalletUsingDELETET> &
  TypeofApiParams<ConfirmWalletUsingPOSTT> &
  TypeofApiParams<FavouriteWalletUsingPOSTT> &
  TypeofApiParams<Pay3dsUsingPOSTT> &
  TypeofApiParams<GetWalletsV2UsingGETT> &
  TypeofApiParams<ChangePayOptionT> &
  TypeofApiParams<DeleteWalletsByServiceUsingDELETET> &
  TypeofApiParams<GetPspListV2UsingGETT> &
  TypeofApiParams<GetPaypalPspsUsingGETT>);

/**
 * Defines an adapter for TypeofApiCall which omit one or more parameters in the signature
 * @param ApiT the type which defines the operation to expose
 * @param K the parameter to omit. undefined means no parameters will be omitted
 */
export type OmitApiCallParams<
  ApiT,
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = (
  op: TypeofApiCall<ApiT>
) => K extends __UNDEFINED_KEY
  ? TypeofApiCall<ApiT>
  : TypeofApiCall<ReplaceRequestParams<ApiT, Omit<RequestParams<ApiT>, K>>>;

/**
 * Defines an adapter for TypeofApiCall which omit one or more parameters in the signature
 * @param ApiT the type which defines the operation to expose
 * @param K the parameter to omit. undefined means no parameters will be omitted
 */
export type WithDefaultsT<
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = OmitApiCallParams<
  | GetAbiListUsingGETT
  | AddWalletsBancomatCardUsingPOSTT
  | GetPansUsingGETT
  | AddWalletsBPayUsingPOSTT
  | GetBpayListUsingGETT
  | PayCreditCardVerificationUsingPOSTT
  | DeletePaymentUsingDELETET
  | CheckPaymentUsingGETT
  | GetPaymentUsingGETT
  | DeleteBySessionCookieExpiredUsingDELETET
  | PaySslUsingPOSTT
  | GetPspListUsingGETT
  | GetAllPspsUsingGETT
  | GetSelectedPspUsingGETT
  | GetPspUsingGETT
  | GetResourcesUsingGETT
  | GetImageWithMediaTypeUsingGETT
  | GetPspLogoUsingGETT
  | GetServiceLogoUsingGETT
  | AddWalletSatispayUsingPOSTT
  | GetConsumerUsingGETT
  | GetTransactionsUsingGETT
  | GetTransactionUsingGETT
  | CheckStatusUsingGETT
  | ResumeUsingPOSTT
  | GetUserUsingGETT
  | SendOtpUsingPOSTT
  | StartSessionUsingGETT
  | VerifyOtpUsingPOSTT
  | GetWalletsUsingGETT
  | AddWalletUsingPOSTT
  | CheckCardBinUsingPOSTT
  | AddWalletCreditCardUsingPOSTT
  | UpdateWalletUsingPUTV2T
  | GetWalletUsingGETT
  | DeleteWalletUsingDELETET
  | ConfirmWalletUsingPOSTT
  | FavouriteWalletUsingPOSTT
  | Pay3dsUsingPOSTT
  | GetWalletsV2UsingGETT
  | ChangePayOptionT
  | DeleteWalletsByServiceUsingDELETET
  | GetPspListV2UsingGETT
  | GetPaypalPspsUsingGETT,
  K
>;

/**
 * Defines a collection of api operations
 * @param K name of the parameters that the Clients masks from the operations
 */
export type Client<
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = K extends __UNDEFINED_KEY
  ? {
      readonly getAbiListUsingGET: TypeofApiCall<GetAbiListUsingGETT>;

      readonly addWalletsBancomatCardUsingPOST: TypeofApiCall<
        AddWalletsBancomatCardUsingPOSTT
      >;

      readonly getPansUsingGET: TypeofApiCall<GetPansUsingGETT>;

      readonly addWalletsBPayUsingPOST: TypeofApiCall<AddWalletsBPayUsingPOSTT>;

      readonly getBpayListUsingGET: TypeofApiCall<GetBpayListUsingGETT>;

      readonly payCreditCardVerificationUsingPOST: TypeofApiCall<
        PayCreditCardVerificationUsingPOSTT
      >;

      readonly deletePaymentUsingDELETE: TypeofApiCall<
        DeletePaymentUsingDELETET
      >;

      readonly checkPaymentUsingGET: TypeofApiCall<CheckPaymentUsingGETT>;

      readonly getPaymentUsingGET: TypeofApiCall<GetPaymentUsingGETT>;

      readonly deleteBySessionCookieExpiredUsingDELETE: TypeofApiCall<
        DeleteBySessionCookieExpiredUsingDELETET
      >;

      readonly paySslUsingPOST: TypeofApiCall<PaySslUsingPOSTT>;

      readonly getPspListUsingGET: TypeofApiCall<GetPspListUsingGETT>;

      readonly getAllPspsUsingGET: TypeofApiCall<GetAllPspsUsingGETT>;

      readonly getSelectedPspUsingGET: TypeofApiCall<GetSelectedPspUsingGETT>;

      readonly getPspUsingGET: TypeofApiCall<GetPspUsingGETT>;

      readonly getResourcesUsingGET: TypeofApiCall<GetResourcesUsingGETT>;

      readonly getImageWithMediaTypeUsingGET: TypeofApiCall<
        GetImageWithMediaTypeUsingGETT
      >;

      readonly getPspLogoUsingGET: TypeofApiCall<GetPspLogoUsingGETT>;

      readonly getServiceLogoUsingGET: TypeofApiCall<GetServiceLogoUsingGETT>;

      readonly addWalletSatispayUsingPOST: TypeofApiCall<
        AddWalletSatispayUsingPOSTT
      >;

      readonly getConsumerUsingGET: TypeofApiCall<GetConsumerUsingGETT>;

      readonly getTransactionsUsingGET: TypeofApiCall<GetTransactionsUsingGETT>;

      readonly getTransactionUsingGET: TypeofApiCall<GetTransactionUsingGETT>;

      readonly checkStatusUsingGET: TypeofApiCall<CheckStatusUsingGETT>;

      readonly resumeUsingPOST: TypeofApiCall<ResumeUsingPOSTT>;

      readonly getUserUsingGET: TypeofApiCall<GetUserUsingGETT>;

      readonly sendOtpUsingPOST: TypeofApiCall<SendOtpUsingPOSTT>;

      readonly startSessionUsingGET: TypeofApiCall<StartSessionUsingGETT>;

      readonly verifyOtpUsingPOST: TypeofApiCall<VerifyOtpUsingPOSTT>;

      readonly getWalletsUsingGET: TypeofApiCall<GetWalletsUsingGETT>;

      readonly addWalletUsingPOST: TypeofApiCall<AddWalletUsingPOSTT>;

      readonly checkCardBinUsingPOST: TypeofApiCall<CheckCardBinUsingPOSTT>;

      readonly addWalletCreditCardUsingPOST: TypeofApiCall<
        AddWalletCreditCardUsingPOSTT
      >;

      readonly updateWalletUsingPUTV2: TypeofApiCall<UpdateWalletUsingPUTV2T>;

      readonly getWalletUsingGET: TypeofApiCall<GetWalletUsingGETT>;

      readonly deleteWalletUsingDELETE: TypeofApiCall<DeleteWalletUsingDELETET>;

      readonly confirmWalletUsingPOST: TypeofApiCall<ConfirmWalletUsingPOSTT>;

      readonly favouriteWalletUsingPOST: TypeofApiCall<
        FavouriteWalletUsingPOSTT
      >;

      readonly pay3dsUsingPOST: TypeofApiCall<Pay3dsUsingPOSTT>;

      readonly getWalletsV2UsingGET: TypeofApiCall<GetWalletsV2UsingGETT>;

      readonly changePayOption: TypeofApiCall<ChangePayOptionT>;

      readonly deleteWalletsByServiceUsingDELETE: TypeofApiCall<
        DeleteWalletsByServiceUsingDELETET
      >;

      readonly getPspListV2UsingGET: TypeofApiCall<GetPspListV2UsingGETT>;

      readonly getPaypalPspsUsingGET: TypeofApiCall<GetPaypalPspsUsingGETT>;
    }
  : {
      readonly getAbiListUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetAbiListUsingGETT,
          Omit<RequestParams<GetAbiListUsingGETT>, K>
        >
      >;

      readonly addWalletsBancomatCardUsingPOST: TypeofApiCall<
        ReplaceRequestParams<
          AddWalletsBancomatCardUsingPOSTT,
          Omit<RequestParams<AddWalletsBancomatCardUsingPOSTT>, K>
        >
      >;

      readonly getPansUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetPansUsingGETT,
          Omit<RequestParams<GetPansUsingGETT>, K>
        >
      >;

      readonly addWalletsBPayUsingPOST: TypeofApiCall<
        ReplaceRequestParams<
          AddWalletsBPayUsingPOSTT,
          Omit<RequestParams<AddWalletsBPayUsingPOSTT>, K>
        >
      >;

      readonly getBpayListUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetBpayListUsingGETT,
          Omit<RequestParams<GetBpayListUsingGETT>, K>
        >
      >;

      readonly payCreditCardVerificationUsingPOST: TypeofApiCall<
        ReplaceRequestParams<
          PayCreditCardVerificationUsingPOSTT,
          Omit<RequestParams<PayCreditCardVerificationUsingPOSTT>, K>
        >
      >;

      readonly deletePaymentUsingDELETE: TypeofApiCall<
        ReplaceRequestParams<
          DeletePaymentUsingDELETET,
          Omit<RequestParams<DeletePaymentUsingDELETET>, K>
        >
      >;

      readonly checkPaymentUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          CheckPaymentUsingGETT,
          Omit<RequestParams<CheckPaymentUsingGETT>, K>
        >
      >;

      readonly getPaymentUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetPaymentUsingGETT,
          Omit<RequestParams<GetPaymentUsingGETT>, K>
        >
      >;

      readonly deleteBySessionCookieExpiredUsingDELETE: TypeofApiCall<
        ReplaceRequestParams<
          DeleteBySessionCookieExpiredUsingDELETET,
          Omit<RequestParams<DeleteBySessionCookieExpiredUsingDELETET>, K>
        >
      >;

      readonly paySslUsingPOST: TypeofApiCall<
        ReplaceRequestParams<
          PaySslUsingPOSTT,
          Omit<RequestParams<PaySslUsingPOSTT>, K>
        >
      >;

      readonly getPspListUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetPspListUsingGETT,
          Omit<RequestParams<GetPspListUsingGETT>, K>
        >
      >;

      readonly getAllPspsUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetAllPspsUsingGETT,
          Omit<RequestParams<GetAllPspsUsingGETT>, K>
        >
      >;

      readonly getSelectedPspUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetSelectedPspUsingGETT,
          Omit<RequestParams<GetSelectedPspUsingGETT>, K>
        >
      >;

      readonly getPspUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetPspUsingGETT,
          Omit<RequestParams<GetPspUsingGETT>, K>
        >
      >;

      readonly getResourcesUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetResourcesUsingGETT,
          Omit<RequestParams<GetResourcesUsingGETT>, K>
        >
      >;

      readonly getImageWithMediaTypeUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetImageWithMediaTypeUsingGETT,
          Omit<RequestParams<GetImageWithMediaTypeUsingGETT>, K>
        >
      >;

      readonly getPspLogoUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetPspLogoUsingGETT,
          Omit<RequestParams<GetPspLogoUsingGETT>, K>
        >
      >;

      readonly getServiceLogoUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetServiceLogoUsingGETT,
          Omit<RequestParams<GetServiceLogoUsingGETT>, K>
        >
      >;

      readonly addWalletSatispayUsingPOST: TypeofApiCall<
        ReplaceRequestParams<
          AddWalletSatispayUsingPOSTT,
          Omit<RequestParams<AddWalletSatispayUsingPOSTT>, K>
        >
      >;

      readonly getConsumerUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetConsumerUsingGETT,
          Omit<RequestParams<GetConsumerUsingGETT>, K>
        >
      >;

      readonly getTransactionsUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetTransactionsUsingGETT,
          Omit<RequestParams<GetTransactionsUsingGETT>, K>
        >
      >;

      readonly getTransactionUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetTransactionUsingGETT,
          Omit<RequestParams<GetTransactionUsingGETT>, K>
        >
      >;

      readonly checkStatusUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          CheckStatusUsingGETT,
          Omit<RequestParams<CheckStatusUsingGETT>, K>
        >
      >;

      readonly resumeUsingPOST: TypeofApiCall<
        ReplaceRequestParams<
          ResumeUsingPOSTT,
          Omit<RequestParams<ResumeUsingPOSTT>, K>
        >
      >;

      readonly getUserUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetUserUsingGETT,
          Omit<RequestParams<GetUserUsingGETT>, K>
        >
      >;

      readonly sendOtpUsingPOST: TypeofApiCall<
        ReplaceRequestParams<
          SendOtpUsingPOSTT,
          Omit<RequestParams<SendOtpUsingPOSTT>, K>
        >
      >;

      readonly startSessionUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          StartSessionUsingGETT,
          Omit<RequestParams<StartSessionUsingGETT>, K>
        >
      >;

      readonly verifyOtpUsingPOST: TypeofApiCall<
        ReplaceRequestParams<
          VerifyOtpUsingPOSTT,
          Omit<RequestParams<VerifyOtpUsingPOSTT>, K>
        >
      >;

      readonly getWalletsUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetWalletsUsingGETT,
          Omit<RequestParams<GetWalletsUsingGETT>, K>
        >
      >;

      readonly addWalletUsingPOST: TypeofApiCall<
        ReplaceRequestParams<
          AddWalletUsingPOSTT,
          Omit<RequestParams<AddWalletUsingPOSTT>, K>
        >
      >;

      readonly checkCardBinUsingPOST: TypeofApiCall<
        ReplaceRequestParams<
          CheckCardBinUsingPOSTT,
          Omit<RequestParams<CheckCardBinUsingPOSTT>, K>
        >
      >;

      readonly addWalletCreditCardUsingPOST: TypeofApiCall<
        ReplaceRequestParams<
          AddWalletCreditCardUsingPOSTT,
          Omit<RequestParams<AddWalletCreditCardUsingPOSTT>, K>
        >
      >;

      readonly updateWalletUsingPUTV2: TypeofApiCall<
        ReplaceRequestParams<
          UpdateWalletUsingPUTV2T,
          Omit<RequestParams<UpdateWalletUsingPUTV2T>, K>
        >
      >;

      readonly getWalletUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetWalletUsingGETT,
          Omit<RequestParams<GetWalletUsingGETT>, K>
        >
      >;

      readonly deleteWalletUsingDELETE: TypeofApiCall<
        ReplaceRequestParams<
          DeleteWalletUsingDELETET,
          Omit<RequestParams<DeleteWalletUsingDELETET>, K>
        >
      >;

      readonly confirmWalletUsingPOST: TypeofApiCall<
        ReplaceRequestParams<
          ConfirmWalletUsingPOSTT,
          Omit<RequestParams<ConfirmWalletUsingPOSTT>, K>
        >
      >;

      readonly favouriteWalletUsingPOST: TypeofApiCall<
        ReplaceRequestParams<
          FavouriteWalletUsingPOSTT,
          Omit<RequestParams<FavouriteWalletUsingPOSTT>, K>
        >
      >;

      readonly pay3dsUsingPOST: TypeofApiCall<
        ReplaceRequestParams<
          Pay3dsUsingPOSTT,
          Omit<RequestParams<Pay3dsUsingPOSTT>, K>
        >
      >;

      readonly getWalletsV2UsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetWalletsV2UsingGETT,
          Omit<RequestParams<GetWalletsV2UsingGETT>, K>
        >
      >;

      readonly changePayOption: TypeofApiCall<
        ReplaceRequestParams<
          ChangePayOptionT,
          Omit<RequestParams<ChangePayOptionT>, K>
        >
      >;

      readonly deleteWalletsByServiceUsingDELETE: TypeofApiCall<
        ReplaceRequestParams<
          DeleteWalletsByServiceUsingDELETET,
          Omit<RequestParams<DeleteWalletsByServiceUsingDELETET>, K>
        >
      >;

      readonly getPspListV2UsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetPspListV2UsingGETT,
          Omit<RequestParams<GetPspListV2UsingGETT>, K>
        >
      >;

      readonly getPaypalPspsUsingGET: TypeofApiCall<
        ReplaceRequestParams<
          GetPaypalPspsUsingGETT,
          Omit<RequestParams<GetPaypalPspsUsingGETT>, K>
        >
      >;
    };

/**
 * Create an instance of a client
 * @param params hash map of parameters thata define the client:
 *  - baseUrl: the base url for every api call (required)
 *  - fetchApi: an implementation of the fetch() web API, depending on the platform (required)
 *  - basePath: optional path to be appended to the baseUrl
 *  - withDefaults: optional adapter to be applied to every operation, to omit some paramenters
 * @returns a collection of api operations
 */
export function createClient<K extends ParamKeys>(params: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults: WithDefaultsT<K>;
  basePath?: string;
}): Client<K>;
export function createClient(params: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults?: undefined;
  basePath?: string;
}): Client;
export function createClient<K extends ParamKeys>({
  baseUrl,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi,
  withDefaults,
  basePath = "/pp-restapi-CD"
}: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults?: WithDefaultsT<K>;
  basePath?: string;
}) {
  const options = {
    baseUrl,
    fetchApi
  };

  const getAbiListUsingGETT: ReplaceRequestParams<
    GetAbiListUsingGETT,
    RequestParams<GetAbiListUsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getAbiListUsingGETDefaultDecoder(),
    url: ({}) => `${basePath}/v1/bancomat/abi`,

    query: ({ ["size"]: size, ["start"]: start, ["abiQuery"]: abiQuery }) =>
      withoutUndefinedValues({
        ["size"]: size,
        ["start"]: start,
        ["abiQuery"]: abiQuery
      })
  };
  const getAbiListUsingGET: TypeofApiCall<GetAbiListUsingGETT> = createFetchRequestForApi(
    getAbiListUsingGETT,
    options
  );

  const addWalletsBancomatCardUsingPOSTT: ReplaceRequestParams<
    AddWalletsBancomatCardUsingPOSTT,
    RequestParams<AddWalletsBancomatCardUsingPOSTT>
  > = {
    method: "post",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: addWalletsBancomatCardUsingPOSTDefaultDecoder(),
    url: ({}) => `${basePath}/v1/bancomat/add-wallets`,

    body: ({ ["bancomatCardsRequest"]: bancomatCardsRequest }) =>
      JSON.stringify(bancomatCardsRequest),

    query: () => withoutUndefinedValues({})
  };
  const addWalletsBancomatCardUsingPOST: TypeofApiCall<AddWalletsBancomatCardUsingPOSTT> = createFetchRequestForApi(
    addWalletsBancomatCardUsingPOSTT,
    options
  );

  const getPansUsingGETT: ReplaceRequestParams<
    GetPansUsingGETT,
    RequestParams<GetPansUsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getPansUsingGETDefaultDecoder(),
    url: ({}) => `${basePath}/v1/bancomat/pans`,

    query: ({ ["abi"]: abi }) => withoutUndefinedValues({ ["abi"]: abi })
  };
  const getPansUsingGET: TypeofApiCall<GetPansUsingGETT> = createFetchRequestForApi(
    getPansUsingGETT,
    options
  );

  const addWalletsBPayUsingPOSTT: ReplaceRequestParams<
    AddWalletsBPayUsingPOSTT,
    RequestParams<AddWalletsBPayUsingPOSTT>
  > = {
    method: "post",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: addWalletsBPayUsingPOSTDefaultDecoder(),
    url: ({}) => `${basePath}/v1/bpay/add-wallets`,

    body: ({ ["bPayRequest"]: bPayRequest }) => JSON.stringify(bPayRequest),

    query: () => withoutUndefinedValues({})
  };
  const addWalletsBPayUsingPOST: TypeofApiCall<AddWalletsBPayUsingPOSTT> = createFetchRequestForApi(
    addWalletsBPayUsingPOSTT,
    options
  );

  const getBpayListUsingGETT: ReplaceRequestParams<
    GetBpayListUsingGETT,
    RequestParams<GetBpayListUsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getBpayListUsingGETDefaultDecoder(),
    url: ({}) => `${basePath}/v1/bpay/list`,

    query: ({ ["abi"]: abi }) => withoutUndefinedValues({ ["abi"]: abi })
  };
  const getBpayListUsingGET: TypeofApiCall<GetBpayListUsingGETT> = createFetchRequestForApi(
    getBpayListUsingGETT,
    options
  );

  const payCreditCardVerificationUsingPOSTT: ReplaceRequestParams<
    PayCreditCardVerificationUsingPOSTT,
    RequestParams<PayCreditCardVerificationUsingPOSTT>
  > = {
    method: "post",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: payCreditCardVerificationUsingPOSTDefaultDecoder(),
    url: ({}) => `${basePath}/v1/payments/cc/actions/pay`,

    body: ({ ["payRequest"]: payRequest }) => JSON.stringify(payRequest),

    query: ({ ["language"]: language }) =>
      withoutUndefinedValues({ ["language"]: language })
  };
  const payCreditCardVerificationUsingPOST: TypeofApiCall<PayCreditCardVerificationUsingPOSTT> = createFetchRequestForApi(
    payCreditCardVerificationUsingPOSTT,
    options
  );

  const deletePaymentUsingDELETET: ReplaceRequestParams<
    DeletePaymentUsingDELETET,
    RequestParams<DeletePaymentUsingDELETET>
  > = {
    method: "delete",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: deletePaymentUsingDELETEDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v1/payments/${id}`,

    query: ({ ["showWallet"]: showWallet }) =>
      withoutUndefinedValues({ ["showWallet"]: showWallet })
  };
  const deletePaymentUsingDELETE: TypeofApiCall<DeletePaymentUsingDELETET> = createFetchRequestForApi(
    deletePaymentUsingDELETET,
    options
  );

  const checkPaymentUsingGETT: ReplaceRequestParams<
    CheckPaymentUsingGETT,
    RequestParams<CheckPaymentUsingGETT>
  > = {
    method: "get",

    headers: () => ({}),

    response_decoder: checkPaymentUsingGETDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v1/payments/${id}/actions/check`,

    query: () => withoutUndefinedValues({})
  };
  const checkPaymentUsingGET: TypeofApiCall<CheckPaymentUsingGETT> = createFetchRequestForApi(
    checkPaymentUsingGETT,
    options
  );

  const getPaymentUsingGETT: ReplaceRequestParams<
    GetPaymentUsingGETT,
    RequestParams<GetPaymentUsingGETT>
  > = {
    method: "get",

    headers: () => ({}),

    response_decoder: getPaymentUsingGETDefaultDecoder(),
    url: ({ ["id"]: id }) =>
      `${basePath}/v1/payments/${id}/actions/check-internal`,

    query: () => withoutUndefinedValues({})
  };
  const getPaymentUsingGET: TypeofApiCall<GetPaymentUsingGETT> = createFetchRequestForApi(
    getPaymentUsingGETT,
    options
  );

  const deleteBySessionCookieExpiredUsingDELETET: ReplaceRequestParams<
    DeleteBySessionCookieExpiredUsingDELETET,
    RequestParams<DeleteBySessionCookieExpiredUsingDELETET>
  > = {
    method: "delete",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteBySessionCookieExpiredUsingDELETEDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v1/payments/${id}/actions/delete`,

    query: ({ ["showWallet"]: showWallet }) =>
      withoutUndefinedValues({ ["showWallet"]: showWallet })
  };
  const deleteBySessionCookieExpiredUsingDELETE: TypeofApiCall<DeleteBySessionCookieExpiredUsingDELETET> = createFetchRequestForApi(
    deleteBySessionCookieExpiredUsingDELETET,
    options
  );

  const paySslUsingPOSTT: ReplaceRequestParams<
    PaySslUsingPOSTT,
    RequestParams<PaySslUsingPOSTT>
  > = {
    method: "post",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: paySslUsingPOSTDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v1/payments/${id}/actions/pay`,

    body: ({ ["payRequest"]: payRequest }) => JSON.stringify(payRequest),

    query: ({ ["language"]: language }) =>
      withoutUndefinedValues({ ["language"]: language })
  };
  const paySslUsingPOST: TypeofApiCall<PaySslUsingPOSTT> = createFetchRequestForApi(
    paySslUsingPOSTT,
    options
  );

  const getPspListUsingGETT: ReplaceRequestParams<
    GetPspListUsingGETT,
    RequestParams<GetPspListUsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getPspListUsingGETDefaultDecoder(),
    url: ({}) => `${basePath}/v1/psps`,

    query: ({
      ["paymentType"]: paymentType,
      ["paymentModel"]: paymentModel,
      ["idPayment"]: idPayment
    }) =>
      withoutUndefinedValues({
        ["paymentType"]: paymentType,
        ["paymentModel"]: paymentModel,
        ["idPayment"]: idPayment
      })
  };
  const getPspListUsingGET: TypeofApiCall<GetPspListUsingGETT> = createFetchRequestForApi(
    getPspListUsingGETT,
    options
  );

  const getAllPspsUsingGETT: ReplaceRequestParams<
    GetAllPspsUsingGETT,
    RequestParams<GetAllPspsUsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getAllPspsUsingGETDefaultDecoder(),
    url: ({}) => `${basePath}/v1/psps/all`,

    query: ({
      ["idWallet"]: idWallet,
      ["idPayment"]: idPayment,
      ["language"]: language
    }) =>
      withoutUndefinedValues({
        ["idWallet"]: idWallet,
        ["idPayment"]: idPayment,
        ["language"]: language
      })
  };
  const getAllPspsUsingGET: TypeofApiCall<GetAllPspsUsingGETT> = createFetchRequestForApi(
    getAllPspsUsingGETT,
    options
  );

  const getSelectedPspUsingGETT: ReplaceRequestParams<
    GetSelectedPspUsingGETT,
    RequestParams<GetSelectedPspUsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getSelectedPspUsingGETDefaultDecoder(),
    url: ({}) => `${basePath}/v1/psps/selected`,

    query: ({
      ["idWallet"]: idWallet,
      ["idPayment"]: idPayment,
      ["language"]: language
    }) =>
      withoutUndefinedValues({
        ["idWallet"]: idWallet,
        ["idPayment"]: idPayment,
        ["language"]: language
      })
  };
  const getSelectedPspUsingGET: TypeofApiCall<GetSelectedPspUsingGETT> = createFetchRequestForApi(
    getSelectedPspUsingGETT,
    options
  );

  const getPspUsingGETT: ReplaceRequestParams<
    GetPspUsingGETT,
    RequestParams<GetPspUsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getPspUsingGETDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v1/psps/${id}`,

    query: () => withoutUndefinedValues({})
  };
  const getPspUsingGET: TypeofApiCall<GetPspUsingGETT> = createFetchRequestForApi(
    getPspUsingGETT,
    options
  );

  const getResourcesUsingGETT: ReplaceRequestParams<
    GetResourcesUsingGETT,
    RequestParams<GetResourcesUsingGETT>
  > = {
    method: "get",

    headers: () => ({}),

    response_decoder: getResourcesUsingGETDefaultDecoder(),
    url: ({}) => `${basePath}/v1/resources`,

    query: () => withoutUndefinedValues({})
  };
  const getResourcesUsingGET: TypeofApiCall<GetResourcesUsingGETT> = createFetchRequestForApi(
    getResourcesUsingGETT,
    options
  );

  const getImageWithMediaTypeUsingGETT: ReplaceRequestParams<
    GetImageWithMediaTypeUsingGETT,
    RequestParams<GetImageWithMediaTypeUsingGETT>
  > = {
    method: "get",

    headers: () => ({}),

    response_decoder: getImageWithMediaTypeUsingGETDefaultDecoder(),
    url: ({ ["imgName"]: imgName }) =>
      `${basePath}/v1/resources/img/${imgName}`,

    query: () => withoutUndefinedValues({})
  };
  const getImageWithMediaTypeUsingGET: TypeofApiCall<GetImageWithMediaTypeUsingGETT> = createFetchRequestForApi(
    getImageWithMediaTypeUsingGETT,
    options
  );

  const getPspLogoUsingGETT: ReplaceRequestParams<
    GetPspLogoUsingGETT,
    RequestParams<GetPspLogoUsingGETT>
  > = {
    method: "get",

    headers: () => ({}),

    response_decoder: getPspLogoUsingGETDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v1/resources/psp/${id}`,

    query: () => withoutUndefinedValues({})
  };
  const getPspLogoUsingGET: TypeofApiCall<GetPspLogoUsingGETT> = createFetchRequestForApi(
    getPspLogoUsingGETT,
    options
  );

  const getServiceLogoUsingGETT: ReplaceRequestParams<
    GetServiceLogoUsingGETT,
    RequestParams<GetServiceLogoUsingGETT>
  > = {
    method: "get",

    headers: () => ({}),

    response_decoder: getServiceLogoUsingGETDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v1/resources/service/${id}`,

    query: () => withoutUndefinedValues({})
  };
  const getServiceLogoUsingGET: TypeofApiCall<GetServiceLogoUsingGETT> = createFetchRequestForApi(
    getServiceLogoUsingGETT,
    options
  );

  const addWalletSatispayUsingPOSTT: ReplaceRequestParams<
    AddWalletSatispayUsingPOSTT,
    RequestParams<AddWalletSatispayUsingPOSTT>
  > = {
    method: "post",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: addWalletSatispayUsingPOSTDefaultDecoder(),
    url: ({}) => `${basePath}/v1/satispay/add-wallet`,

    body: ({ ["satispayRequest"]: satispayRequest }) =>
      JSON.stringify(satispayRequest),

    query: () => withoutUndefinedValues({})
  };
  const addWalletSatispayUsingPOST: TypeofApiCall<AddWalletSatispayUsingPOSTT> = createFetchRequestForApi(
    addWalletSatispayUsingPOSTT,
    options
  );

  const getConsumerUsingGETT: ReplaceRequestParams<
    GetConsumerUsingGETT,
    RequestParams<GetConsumerUsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getConsumerUsingGETDefaultDecoder(),
    url: ({}) => `${basePath}/v1/satispay/consumers`,

    query: () => withoutUndefinedValues({})
  };
  const getConsumerUsingGET: TypeofApiCall<GetConsumerUsingGETT> = createFetchRequestForApi(
    getConsumerUsingGETT,
    options
  );

  const getTransactionsUsingGETT: ReplaceRequestParams<
    GetTransactionsUsingGETT,
    RequestParams<GetTransactionsUsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getTransactionsUsingGETDefaultDecoder(),
    url: ({}) => `${basePath}/v1/transactions`,

    query: () => withoutUndefinedValues({})
  };
  const getTransactionsUsingGET: TypeofApiCall<GetTransactionsUsingGETT> = createFetchRequestForApi(
    getTransactionsUsingGETT,
    options
  );

  const getTransactionUsingGETT: ReplaceRequestParams<
    GetTransactionUsingGETT,
    RequestParams<GetTransactionUsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getTransactionUsingGETDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v1/transactions/${id}`,

    query: () => withoutUndefinedValues({})
  };
  const getTransactionUsingGET: TypeofApiCall<GetTransactionUsingGETT> = createFetchRequestForApi(
    getTransactionUsingGETT,
    options
  );

  const checkStatusUsingGETT: ReplaceRequestParams<
    CheckStatusUsingGETT,
    RequestParams<CheckStatusUsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: checkStatusUsingGETDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v1/transactions/${id}/actions/check`,

    query: () => withoutUndefinedValues({})
  };
  const checkStatusUsingGET: TypeofApiCall<CheckStatusUsingGETT> = createFetchRequestForApi(
    checkStatusUsingGETT,
    options
  );

  const resumeUsingPOSTT: ReplaceRequestParams<
    ResumeUsingPOSTT,
    RequestParams<ResumeUsingPOSTT>
  > = {
    method: "post",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: resumeUsingPOSTDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v1/transactions/${id}/actions/resume`,

    body: ({ ["resumeRequest"]: resumeRequest }) =>
      JSON.stringify(resumeRequest),

    query: ({ ["language"]: language }) =>
      withoutUndefinedValues({ ["language"]: language })
  };
  const resumeUsingPOST: TypeofApiCall<ResumeUsingPOSTT> = createFetchRequestForApi(
    resumeUsingPOSTT,
    options
  );

  const getUserUsingGETT: ReplaceRequestParams<
    GetUserUsingGETT,
    RequestParams<GetUserUsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getUserUsingGETDefaultDecoder(),
    url: ({}) => `${basePath}/v1/users`,

    query: () => withoutUndefinedValues({})
  };
  const getUserUsingGET: TypeofApiCall<GetUserUsingGETT> = createFetchRequestForApi(
    getUserUsingGETT,
    options
  );

  const sendOtpUsingPOSTT: ReplaceRequestParams<
    SendOtpUsingPOSTT,
    RequestParams<SendOtpUsingPOSTT>
  > = {
    method: "post",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: sendOtpUsingPOSTDefaultDecoder(),
    url: ({}) => `${basePath}/v1/users/actions/send-otp`,

    body: ({ ["sendOtpRequest"]: sendOtpRequest }) =>
      JSON.stringify(sendOtpRequest),

    query: ({ ["language"]: language }) =>
      withoutUndefinedValues({ ["language"]: language })
  };
  const sendOtpUsingPOST: TypeofApiCall<SendOtpUsingPOSTT> = createFetchRequestForApi(
    sendOtpUsingPOSTT,
    options
  );

  const startSessionUsingGETT: ReplaceRequestParams<
    StartSessionUsingGETT,
    RequestParams<StartSessionUsingGETT>
  > = {
    method: "get",

    headers: () => ({}),

    response_decoder: startSessionUsingGETDefaultDecoder(),
    url: ({}) => `${basePath}/v1/users/actions/start-session`,

    query: ({ ["token"]: token }) =>
      withoutUndefinedValues({ ["token"]: token })
  };
  const startSessionUsingGET: TypeofApiCall<StartSessionUsingGETT> = createFetchRequestForApi(
    startSessionUsingGETT,
    options
  );

  const verifyOtpUsingPOSTT: ReplaceRequestParams<
    VerifyOtpUsingPOSTT,
    RequestParams<VerifyOtpUsingPOSTT>
  > = {
    method: "post",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: verifyOtpUsingPOSTDefaultDecoder(),
    url: ({}) => `${basePath}/v1/users/actions/verify-otp`,

    body: ({ ["verifyOtpRequest"]: verifyOtpRequest }) =>
      JSON.stringify(verifyOtpRequest),

    query: () => withoutUndefinedValues({})
  };
  const verifyOtpUsingPOST: TypeofApiCall<VerifyOtpUsingPOSTT> = createFetchRequestForApi(
    verifyOtpUsingPOSTT,
    options
  );

  const getWalletsUsingGETT: ReplaceRequestParams<
    GetWalletsUsingGETT,
    RequestParams<GetWalletsUsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getWalletsUsingGETDefaultDecoder(),
    url: ({}) => `${basePath}/v1/wallet`,

    query: () => withoutUndefinedValues({})
  };
  const getWalletsUsingGET: TypeofApiCall<GetWalletsUsingGETT> = createFetchRequestForApi(
    getWalletsUsingGETT,
    options
  );

  const addWalletUsingPOSTT: ReplaceRequestParams<
    AddWalletUsingPOSTT,
    RequestParams<AddWalletUsingPOSTT>
  > = {
    method: "post",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: addWalletUsingPOSTDefaultDecoder(),
    url: ({}) => `${basePath}/v1/wallet`,

    body: ({ ["walletRequest"]: walletRequest }) =>
      JSON.stringify(walletRequest),

    query: ({ ["language"]: language }) =>
      withoutUndefinedValues({ ["language"]: language })
  };
  const addWalletUsingPOST: TypeofApiCall<AddWalletUsingPOSTT> = createFetchRequestForApi(
    addWalletUsingPOSTT,
    options
  );

  const checkCardBinUsingPOSTT: ReplaceRequestParams<
    CheckCardBinUsingPOSTT,
    RequestParams<CheckCardBinUsingPOSTT>
  > = {
    method: "post",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: checkCardBinUsingPOSTDefaultDecoder(),
    url: ({}) => `${basePath}/v1/wallet/actions/check-card-bin`,

    body: ({ ["checkCardBinRequest"]: checkCardBinRequest }) =>
      JSON.stringify(checkCardBinRequest),

    query: () => withoutUndefinedValues({})
  };
  const checkCardBinUsingPOST: TypeofApiCall<CheckCardBinUsingPOSTT> = createFetchRequestForApi(
    checkCardBinUsingPOSTT,
    options
  );

  const addWalletCreditCardUsingPOSTT: ReplaceRequestParams<
    AddWalletCreditCardUsingPOSTT,
    RequestParams<AddWalletCreditCardUsingPOSTT>
  > = {
    method: "post",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: addWalletCreditCardUsingPOSTDefaultDecoder(),
    url: ({}) => `${basePath}/v1/wallet/cc`,

    body: ({ ["walletRequest"]: walletRequest }) =>
      JSON.stringify(walletRequest),

    query: () => withoutUndefinedValues({})
  };
  const addWalletCreditCardUsingPOST: TypeofApiCall<AddWalletCreditCardUsingPOSTT> = createFetchRequestForApi(
    addWalletCreditCardUsingPOSTT,
    options
  );

  const updateWalletUsingPUTV2T: ReplaceRequestParams<
    UpdateWalletUsingPUTV2T,
    RequestParams<UpdateWalletUsingPUTV2T>
  > = {
    method: "put",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: updateWalletUsingPUTV2DefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v2/wallet/${id}`,

    body: ({ ["walletRequest"]: walletRequest }) =>
      JSON.stringify(walletRequest),

    query: () => withoutUndefinedValues({})
  };
  const updateWalletUsingPUTV2: TypeofApiCall<UpdateWalletUsingPUTV2T> = createFetchRequestForApi(
    updateWalletUsingPUTV2T,
    options
  );

  const getWalletUsingGETT: ReplaceRequestParams<
    GetWalletUsingGETT,
    RequestParams<GetWalletUsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getWalletUsingGETDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v1/wallet/${id}`,

    query: () => withoutUndefinedValues({})
  };
  const getWalletUsingGET: TypeofApiCall<GetWalletUsingGETT> = createFetchRequestForApi(
    getWalletUsingGETT,
    options
  );

  const deleteWalletUsingDELETET: ReplaceRequestParams<
    DeleteWalletUsingDELETET,
    RequestParams<DeleteWalletUsingDELETET>
  > = {
    method: "delete",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteWalletUsingDELETEDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v1/wallet/${id}`,

    query: () => withoutUndefinedValues({})
  };
  const deleteWalletUsingDELETE: TypeofApiCall<DeleteWalletUsingDELETET> = createFetchRequestForApi(
    deleteWalletUsingDELETET,
    options
  );

  const confirmWalletUsingPOSTT: ReplaceRequestParams<
    ConfirmWalletUsingPOSTT,
    RequestParams<ConfirmWalletUsingPOSTT>
  > = {
    method: "post",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: confirmWalletUsingPOSTDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v1/wallet/${id}/actions/confirm`,

    body: () => "{}",

    query: () => withoutUndefinedValues({})
  };
  const confirmWalletUsingPOST: TypeofApiCall<ConfirmWalletUsingPOSTT> = createFetchRequestForApi(
    confirmWalletUsingPOSTT,
    options
  );

  const favouriteWalletUsingPOSTT: ReplaceRequestParams<
    FavouriteWalletUsingPOSTT,
    RequestParams<FavouriteWalletUsingPOSTT>
  > = {
    method: "post",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: favouriteWalletUsingPOSTDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v1/wallet/${id}/actions/favourite`,

    body: () => "{}",

    query: () => withoutUndefinedValues({})
  };
  const favouriteWalletUsingPOST: TypeofApiCall<FavouriteWalletUsingPOSTT> = createFetchRequestForApi(
    favouriteWalletUsingPOSTT,
    options
  );

  const pay3dsUsingPOSTT: ReplaceRequestParams<
    Pay3dsUsingPOSTT,
    RequestParams<Pay3dsUsingPOSTT>
  > = {
    method: "post",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: pay3dsUsingPOSTDefaultDecoder(),
    url: ({ ["id"]: id }) => `${basePath}/v2/payments/${id}/actions/pay`,

    body: ({ ["payRequest"]: payRequest }) => JSON.stringify(payRequest),

    query: ({ ["language"]: language }) =>
      withoutUndefinedValues({ ["language"]: language })
  };
  const pay3dsUsingPOST: TypeofApiCall<Pay3dsUsingPOSTT> = createFetchRequestForApi(
    pay3dsUsingPOSTT,
    options
  );

  const getWalletsV2UsingGETT: ReplaceRequestParams<
    GetWalletsV2UsingGETT,
    RequestParams<GetWalletsV2UsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getWalletsV2UsingGETDefaultDecoder(),
    url: ({}) => `${basePath}/v2/wallet`,

    query: () => withoutUndefinedValues({})
  };
  const getWalletsV2UsingGET: TypeofApiCall<GetWalletsV2UsingGETT> = createFetchRequestForApi(
    getWalletsV2UsingGETT,
    options
  );

  const changePayOptionT: ReplaceRequestParams<
    ChangePayOptionT,
    RequestParams<ChangePayOptionT>
  > = {
    method: "put",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: changePayOptionDefaultDecoder(),
    url: ({ ["idWallet"]: idWallet }) =>
      `${basePath}/v2/wallet/${idWallet}/payment-status`,

    body: ({ ["payRequest"]: payRequest }) => JSON.stringify(payRequest),

    query: () => withoutUndefinedValues({})
  };
  const changePayOption: TypeofApiCall<ChangePayOptionT> = createFetchRequestForApi(
    changePayOptionT,
    options
  );

  const deleteWalletsByServiceUsingDELETET: ReplaceRequestParams<
    DeleteWalletsByServiceUsingDELETET,
    RequestParams<DeleteWalletsByServiceUsingDELETET>
  > = {
    method: "delete",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer,

      "Content-Type": "application/json"
    }),
    response_decoder: deleteWalletsByServiceUsingDELETEDefaultDecoder(),
    url: ({}) => `${basePath}/v2/wallet/delete-wallets`,

    query: ({ ["service"]: service }) =>
      withoutUndefinedValues({ ["service"]: service })
  };
  const deleteWalletsByServiceUsingDELETE: TypeofApiCall<DeleteWalletsByServiceUsingDELETET> = createFetchRequestForApi(
    deleteWalletsByServiceUsingDELETET,
    options
  );

  const getPspListV2UsingGETT: ReplaceRequestParams<
    GetPspListV2UsingGETT,
    RequestParams<GetPspListV2UsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getPspListV2UsingGETDefaultDecoder(),
    url: ({ ["idPayment"]: idPayment }) =>
      `${basePath}/v2/payments/${idPayment}/psps`,

    query: ({
      ["idWallet"]: idWallet,
      ["cellphoneNumber"]: cellphoneNumber,
      ["externalPsId"]: externalPsId,
      ["language"]: language,
      ["isList"]: isList
    }) =>
      withoutUndefinedValues({
        ["idWallet"]: idWallet,
        ["cellphoneNumber"]: cellphoneNumber,
        ["externalPsId"]: externalPsId,
        ["language"]: language,
        ["isList"]: isList
      })
  };
  const getPspListV2UsingGET: TypeofApiCall<GetPspListV2UsingGETT> = createFetchRequestForApi(
    getPspListV2UsingGETT,
    options
  );

  const getPaypalPspsUsingGETT: ReplaceRequestParams<
    GetPaypalPspsUsingGETT,
    RequestParams<GetPaypalPspsUsingGETT>
  > = {
    method: "get",

    headers: ({ ["Bearer"]: Bearer }: { Bearer: string }) => ({
      Authorization: Bearer
    }),
    response_decoder: getPaypalPspsUsingGETDefaultDecoder(),
    url: ({}) => `${basePath}/v3/paypal/psps`,

    query: ({ ["language"]: language }) =>
      withoutUndefinedValues({ ["language"]: language })
  };
  const getPaypalPspsUsingGET: TypeofApiCall<GetPaypalPspsUsingGETT> = createFetchRequestForApi(
    getPaypalPspsUsingGETT,
    options
  );

  return {
    getAbiListUsingGET: (withDefaults || identity)(getAbiListUsingGET),
    addWalletsBancomatCardUsingPOST: (withDefaults || identity)(
      addWalletsBancomatCardUsingPOST
    ),
    getPansUsingGET: (withDefaults || identity)(getPansUsingGET),
    addWalletsBPayUsingPOST: (withDefaults || identity)(
      addWalletsBPayUsingPOST
    ),
    getBpayListUsingGET: (withDefaults || identity)(getBpayListUsingGET),
    payCreditCardVerificationUsingPOST: (withDefaults || identity)(
      payCreditCardVerificationUsingPOST
    ),
    deletePaymentUsingDELETE: (withDefaults || identity)(
      deletePaymentUsingDELETE
    ),
    checkPaymentUsingGET: (withDefaults || identity)(checkPaymentUsingGET),
    getPaymentUsingGET: (withDefaults || identity)(getPaymentUsingGET),
    deleteBySessionCookieExpiredUsingDELETE: (withDefaults || identity)(
      deleteBySessionCookieExpiredUsingDELETE
    ),
    paySslUsingPOST: (withDefaults || identity)(paySslUsingPOST),
    getPspListUsingGET: (withDefaults || identity)(getPspListUsingGET),
    getAllPspsUsingGET: (withDefaults || identity)(getAllPspsUsingGET),
    getSelectedPspUsingGET: (withDefaults || identity)(getSelectedPspUsingGET),
    getPspUsingGET: (withDefaults || identity)(getPspUsingGET),
    getResourcesUsingGET: (withDefaults || identity)(getResourcesUsingGET),
    getImageWithMediaTypeUsingGET: (withDefaults || identity)(
      getImageWithMediaTypeUsingGET
    ),
    getPspLogoUsingGET: (withDefaults || identity)(getPspLogoUsingGET),
    getServiceLogoUsingGET: (withDefaults || identity)(getServiceLogoUsingGET),
    addWalletSatispayUsingPOST: (withDefaults || identity)(
      addWalletSatispayUsingPOST
    ),
    getConsumerUsingGET: (withDefaults || identity)(getConsumerUsingGET),
    getTransactionsUsingGET: (withDefaults || identity)(
      getTransactionsUsingGET
    ),
    getTransactionUsingGET: (withDefaults || identity)(getTransactionUsingGET),
    checkStatusUsingGET: (withDefaults || identity)(checkStatusUsingGET),
    resumeUsingPOST: (withDefaults || identity)(resumeUsingPOST),
    getUserUsingGET: (withDefaults || identity)(getUserUsingGET),
    sendOtpUsingPOST: (withDefaults || identity)(sendOtpUsingPOST),
    startSessionUsingGET: (withDefaults || identity)(startSessionUsingGET),
    verifyOtpUsingPOST: (withDefaults || identity)(verifyOtpUsingPOST),
    getWalletsUsingGET: (withDefaults || identity)(getWalletsUsingGET),
    addWalletUsingPOST: (withDefaults || identity)(addWalletUsingPOST),
    checkCardBinUsingPOST: (withDefaults || identity)(checkCardBinUsingPOST),
    addWalletCreditCardUsingPOST: (withDefaults || identity)(
      addWalletCreditCardUsingPOST
    ),
    updateWalletUsingPUTV2: (withDefaults || identity)(updateWalletUsingPUTV2),
    getWalletUsingGET: (withDefaults || identity)(getWalletUsingGET),
    deleteWalletUsingDELETE: (withDefaults || identity)(
      deleteWalletUsingDELETE
    ),
    confirmWalletUsingPOST: (withDefaults || identity)(confirmWalletUsingPOST),
    favouriteWalletUsingPOST: (withDefaults || identity)(
      favouriteWalletUsingPOST
    ),
    pay3dsUsingPOST: (withDefaults || identity)(pay3dsUsingPOST),
    getWalletsV2UsingGET: (withDefaults || identity)(getWalletsV2UsingGET),
    changePayOption: (withDefaults || identity)(changePayOption),
    deleteWalletsByServiceUsingDELETE: (withDefaults || identity)(
      deleteWalletsByServiceUsingDELETE
    ),
    getPspListV2UsingGET: (withDefaults || identity)(getPspListV2UsingGET),
    getPaypalPspsUsingGET: (withDefaults || identity)(getPaypalPspsUsingGET)
  };
}
